import styled, { css } from 'styled-components';

import { ItemProps } from './SelectableRectangle';
import { flexGap } from '../../../utils/flexGap';

export const SubItemsLabel = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		color: ${theme.colors.brand.text};
	`}
`;

export const SelectableRectangleAppend = styled.div`
	width: 22px;
	height: 22px;

	& img {
		width: 100%;
	}
`;

export const SelectableRectangleContainer = styled.div<ItemProps>`
	${({ theme, selected, disabled, type }) => css`
		width: 100%;
		height: 63px;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		${flexGap(`${8}px`, false)}
		cursor: pointer;

		${selected
		? type === 'primary' && `border: 2px solid ${theme.colors.brand.accent[300]}`
		: type === 'primary' && `border: 2px solid ${theme.colors.neutral[200]}`};
		border-radius: 5px;

		${type === 'secondary' && `background-color: ${theme.colors.neutral[300]};`}
		${disabled && 'opacity: 0.6;'}

		&:hover {
			${type === 'primary' && `border: 2px solid ${theme.colors.brand.accent[300]};`}
		}

		@media ${theme.screens.screenGTS} {
		}
	`}
`;

export const SelectableRectangleLabel = styled.div<ItemProps>`
	${({ theme, selected }) => css`
		font-size: ${theme.fontSizes.s};
		font-weight: ${theme.fontWeights.medium};
		text-wrap: balance;
		${selected ? `color: ${theme.colors.brand.primary[300]}` : `color: ${theme.colors.brand.text}`};

		&:hover {
			color: ${theme.colors.brand.primary[300]};
		}
	`}
`;
